import { Component, Input, Output, OnInit, EventEmitter } from '@angular/core';
import { Router, ActivatedRoute } from "@angular/router";


@Component({
  selector: 'app-reusable-table',
  templateUrl: './reusable-table.component.html',
  styleUrls: ['./reusable-table.component.less']
})

export class ReusableTableComponent implements OnInit {
constructor(public router: Router,private route: ActivatedRoute){}
  readonly DEFAULT_PAGE: number = 1;
  readonly DEFAULT_SIZE: number = 15;
  @Input() list;
  @Input() collectionSize;
  @Input() tableName;
  @Input() wikiLink;
  @Output() createNew:EventEmitter<any> = new EventEmitter();
  @Output() deleteSelected = new EventEmitter<any[]>();
  isAllSelected = false;
  setDeleteAll = false;
  user: any;

  page: number = 2;
  previousPage: number = 1;
  pageSize: number = 15;
  params: any = {
    page: 1,
    size: 15,
  };
  showAction = false;
  @Input() tableHead;

  createNewItem(){
    this.createNew.emit()
  }
  ngOnInit(): void {
    this.route.queryParams.subscribe((queryParams) => {
      this.params = this.sanitizeQueryParams(queryParams);
      this.page= queryParams.page ? queryParams.page : 1
      this.pageSize = queryParams.size ? queryParams.size : 15
      this.isAllSelected = false;
      this.setDeleteAll = false;
    });
    const entityInclude = ['/endpoint', '/testcase', '/testsuite', '/mastersuite'];
    this.showAction = entityInclude.some(entityName => this.router.url.includes(entityName));
    this.user = JSON.parse(localStorage.getItem('user'));
    this.getWikiLink();
  }
  sanitizeQueryParams(params: any) {
    let newParams = { ...params, page: parseInt(params.page), size: parseInt(params.size) };
    if (isNaN(newParams.page)) newParams.page = this.DEFAULT_PAGE;
    if (isNaN(newParams.size)) newParams.size = this.DEFAULT_SIZE;
    return newParams;
  }
  setPageAndSize() {
    this.page = this.params.page;
    this.pageSize = this.params.size;
  }
  onPageChange(page: number) {
    if (page !== this.previousPage) {
      this.previousPage = page;
      this.doSearch();
    }
  }
  doSearch(formValues: any = null) {
    let collection = {
      ...this.params,
      page: this.page,
      size: this.pageSize,
    };

    if (formValues) collection = { ...collection, ...formValues };

    this.router.navigate(["."], {
      relativeTo: this.route,
      queryParams: collection,
    });
  }
  onSizeChange(size: number) {
    this.page = 1;
    this.pageSize = size;
    this.doSearch();
  }
  toggleAllItems() {
    this.isAllSelected = !this.isAllSelected;
    this.setDeleteAll = this.isAllSelected;
    this.list.forEach(item => item.selected = this.isAllSelected);
  }

  optionToggled(index: string | number) {
    this.list[index].selected = !this.list[index].selected;
    this.setDeleteAll = false;
    let count = 0;
    this.list.forEach((validation) => {
      if (validation.selected) {
        this.setDeleteAll = true;
        count++;
      }
    });
    if (count === this.list.length) {
      this.isAllSelected = true;
    } else {
      this.isAllSelected = false;
    }
  }

  deleteSelectedItems() {
    const selectedItems = this.list.filter(item => item.selected);
    this.deleteSelected.emit(selectedItems);
  }
  resetSelection() {
    this.isAllSelected = false;
    this.setDeleteAll = false;
  }

  getWikiLink(){
    switch(this.tableName.toLowerCase()) {
      case 'endpoint':
        this.wikiLink = 'https://wiki.corp.adobe.com/display/Relay/03.+API+Endpoint+Set+Up';
        break;
      case 'testcase':
        this.wikiLink = 'https://wiki.corp.adobe.com/display/Relay/05.Test+Case+Set+Up';
        break;
      case 'testsuite':
        this.wikiLink = 'https://wiki.corp.adobe.com/pages/viewpage.action?pageId=3050222591';
        break;
      case 'mastersuite':
        this.wikiLink = 'https://wiki.corp.adobe.com/pages/viewpage.action?pageId=3271454782';
        break;
      default:
          this.wikiLink = this.wikiLink;
        break;
    }
  }
}
